// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"143":"app","315":"lib/react","489":"lib/ui-lib","794":"lib/vendor"}[chunkId] + "." + {"143":"64cfc32b","315":"9df2ccef","489":"45a92614","794":"cbe58c26"}[chunkId] + ".js";
};